import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./CarouselScreen.css";
import { useNavigate } from "react-router-dom";
// Remove hardcoded cards array

const CarouselScreen = ({ cards = [] }) => {
  const [current, setCurrent] = useState(2); // Main card index, starting at center
  const navigate = useNavigate();
  if (!cards.length) return null; // Optionally render a fallback or nothing

  const settings = {
    dots: true,
    infinite: true,
    speed: 700,
    slidesToShow: 5, // <-- Change this to 5
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "0px",
    autoplay: true,
    autoplaySpeed: 2500,
    arrows: false,
    beforeChange: (oldIndex, newIndex) => setCurrent(newIndex),
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 3, // Show 3 on tablet
          centerMode: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1.7, // Show 1 on mobile
          centerMode: true,
        },
      },
    ],
    // Custom dots styling handled in CSS
    appendDots: (dots) => (
      <div>
        <ul style={{ margin: "0px" }}> {dots} </ul>
      </div>
    ),
    customPaging: () => <div className="custom-dot" />,
  };

  // Circular indices for side cards
  const prevIdx = (current - 1 + cards.length) % cards.length;
  const nextIdx = (current + 1) % cards.length;

  const navigateToLearnDetail = async (processId) => {

    console.log("processId LISY", processId);
    
    navigate(`/learn/${processId}`);
  };

  return (
    <div className="pt-5">
      <p className="carousel-title ct-text-light ct-cirka-size-22 ">
        Trending series
      </p>
      <div
        className="carousel-slider-wrapper pointer"
       
      >
        <Slider {...settings} className="carousel-slider">
          {cards.map((card, idx) => {
            let cardClass = "carousel-card";
            let rel = (idx - current + cards.length) % cards.length;
            if (rel === 0) cardClass += " main"; // center
            else if (rel === 1 || rel === cards.length - 1)
              cardClass += " large"; // immediate left/right
            else cardClass += " small"; // far left/right
            return (
              <div key={idx} className={cardClass}  onClick={() => navigateToLearnDetail(card?.processId)}>
                <div
                  className="carousel-card-img"
                  style={{
                    backgroundImage: `url(${card.thumbnail || card.img})`,
                  }}
                >
                  <img
                    src={card.thumbnail || card.img}
                    alt={
                      card.itemName ||
                      card.title ||
                      `Trending series ${idx + 1}`
                    }
                    className="carousel-img-tag"
                  />
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    </div>
  );
};

export default CarouselScreen;
